import { render, staticRenderFns } from "./info-badge.vue?vue&type=template&id=5b20d208"
import script from "./info-badge.vue?vue&type=script&lang=js"
export * from "./info-badge.vue?vue&type=script&lang=js"
import style0 from "./info-badge.vue?vue&type=style&index=0&id=5b20d208&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports